import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import 'github-markdown-css/github-markdown-light.css';
import Drawer from '../common/Drawer';
import styles from './ReleaseFlowDrawer.module.css';

const ICO_BOOK = 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z';

const ICON_STYLE = {
  background: 'var(--brand-tint)',
  color: 'var(--brand-primary)',
};

export default function ReleaseFlowDrawer({ open, onClose }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || content) return;
    setLoading(true);
    fetch('/docs/release-flow-2026.md')
      .then(r => { if (!r.ok) throw new Error('Not found'); return r.text(); })
      .then(text => { setContent(text); setLoading(false); })
      .catch(() => { setError('Failed to load documentation.'); setLoading(false); });
  }, [open, content]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      icon={ICO_BOOK}
      iconStyle={ICON_STYLE}
      title="2026 Release Flow Guide"
      subtitle="Release Automation Portal"
    >
      {loading && (
        <div className={styles.loadingWrap}>
          <div className={styles.spinner} />
        </div>
      )}
      {error && <div className={styles.errorMsg}>{error}</div>}
      {content && !loading && (
        <div className={`markdown-body ${styles.markdown}`}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      )}
    </Drawer>
  );
}
